<template>
    <div>
      <section>
        <div class="section-inner">
          <div class="section-cont">
            <h2>가맹점 개설문의</h2>
            <p class="site-path">
              <span>Home</span>&nbsp;&gt;&nbsp;
              <span>PARTNERSHIP</span>&nbsp;&gt;&nbsp;
              <span>가맹점 개설문의</span>
            </p>
          </div>

          <app-footer/>
        </div>
      </section>
    </div>
</template>
<script>
import AppFooter from '../../AppFooter.vue';

export default {
  components: { AppFooter },
  name: 'StoreOpenInquirePostEdit',
}
</script>